import React, {FC} from "react";
import {Badge, Flex} from "@chakra-ui/react";
import {CustomLink} from "../../views/Menu/CustomLink";
import {useInactiveOrderReminderPendingCount} from "../../hooks/useInactiveOrderReminderPendingCount";
import {formatInactiveOrderReminderPendingBadge} from "../../shared/utils/inactiveOrderReminderPendingBadge";

type Props = {
    onNavigate: () => void;
};

export const InactiveOrderReminderMenuLink: FC<Props> = ({onNavigate}) => {
    const pendingCount = useInactiveOrderReminderPendingCount();
    const badgeText = formatInactiveOrderReminderPendingBadge(pendingCount);

    return (
        <CustomLink onClick={onNavigate}>
            <Flex as="span" align="center" display="inline-flex">
                Order reminders
                {badgeText != null && (
                    <Badge
                        ml={2}
                        bg="red.500"
                        color="white"
                        borderRadius="full"
                        minW="18px"
                        h="18px"
                        px={badgeText.length > 2 ? 1 : 0}
                        fontSize="10px"
                        fontWeight="bold"
                        lineHeight="18px"
                        display="inline-flex"
                        alignItems="center"
                        justifyContent="center"
                    >
                        {badgeText}
                    </Badge>
                )}
            </Flex>
        </CustomLink>
    );
};

export default InactiveOrderReminderMenuLink;
